import { noop } from 'lodash';

import useApolloQuery from 'shared/hooks/use-apollo-query';
import useCart from 'shared/hooks/use-cart';
import { GetPaymentsCheckoutCredentialsDocument } from 'src/gql/graphql';

export function useCheckoutCredentials(adapter) {
  const Cart = useCart();
  const {
    order: { dispensary },
  } = Cart;

  const query = GetPaymentsCheckoutCredentialsDocument;
  const variables = { adapter, dispensaryId: dispensary?.id };
  const dataKey = 'getPaymentsCheckoutCredentials';

  const { data = {}, loading, refetch } = useApolloQuery(query, variables, {
    skip: !dispensary,
  });

  return [data[dataKey], loading ? noop : refetch];
}
